export default {
  profile: {
    backToDashboard: 'general.backToDashboard',
    title: 'profile.title',
    clinicName: 'profile.clinicName',
    yourPosition: 'profile.yourPosition',
    yourFullName: 'profile.yourFullName',
    phoneNumber: 'profile.phoneNumber',
    email: 'profile.email',
    saveChanges: 'profile.saveChanges',
  },
};
